import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Navigate } from 'react-router-dom';
import './App.css';
import LoginForm from './HomeMgmt/LoginForm';
import StudentManagement from './StudentMgmt';
import FeeManagement from './FeeManagement';
import Dashboard from './Dashboard';
import { AuthProvider, useAuth } from './AuthContext';
import AllFeeReport from './Report/AllFeeReport';
import ClassFeeBookMaster from './ClassFeeManagement';

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

function AppContent() {
  const { isAuthenticated, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  return (
    <Router>
      <div className="app-container">
        {isAuthenticated && (
          <>
            <div className="mobile-header">
              <button className="hamburger" onClick={toggleSidebar}>
                ☰
              </button>
              <h2>Dashboard</h2>
            </div>

            <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
              <div className="logo">
                <h2>Menu</h2>
              </div>
              <ul className="menu">
                <li><Link to="/students" onClick={toggleSidebar}>Student Management</Link></li>
                <li><Link to="/fees" onClick={toggleSidebar}>Fee Management</Link></li>
                <li><Link to="/all-fee-report" onClick={toggleSidebar}>All Fee Report</Link></li>
                <li><Link to="/class-fee-master" onClick={toggleSidebar}>Fee Book Master</Link></li>
                <li><button onClick={() => { logout(); setSidebarOpen(false); }} className="logout-button">Logout</button></li>
              </ul>
            </div>
          </>
        )}

        <div className="content">
          <Routes>
            <Route path="/login" element={!isAuthenticated ? <LoginForm /> : <Navigate to="/dashboard" />} />
            <Route path="/dashboard" element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />} />
            <Route path="/students" element={isAuthenticated ? <StudentManagement /> : <Navigate to="/login" />} />
            <Route path="/fees" element={isAuthenticated ? <FeeManagement /> : <Navigate to="/login" />} />
            <Route path="/all-fee-report" element={isAuthenticated ? <AllFeeReport /> : <Navigate to="/login" />} />
            <Route path="/class-fee-master" element={isAuthenticated ? <ClassFeeBookMaster /> : <Navigate to="/login" />} />
            <Route path="/" element={<Navigate to="/login" />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
